import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useServiceRequestsCounts } from "../../hooks/useServiceRequestsCounts";

const ServicesRequestsTabsNavigation = () => {
  const { t } = useTranslation("goService", { keyPrefix: "myRequestsPage" });
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("category") || "new";

  const { newCount, contractCount, historyCount, isLoading } = useServiceRequestsCounts();

  const TABS = [
    {
      label: "new",
      badge: newCount,
    },
    {
      label: "contract",
      badge: contractCount,
    },
    {
      label: "history",
      badge: historyCount,
    },
  ] as const;
  type TabType = (typeof TABS)[number]["label"];

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("category", newValue);
    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      aria-label="service category tabs"
      sx={styles.tabs}
      variant="scrollable"
      scrollButtons="auto"
    >
      {TABS.map(({ label, badge }) => {
        return (
          <Tab
            key={label}
            label={
              <>
                {t(label)}
                {!isLoading && badge > 0 && (
                  <Box component="span" sx={styles.badge}>
                    {badge}
                  </Box>
                )}
              </>
            }
            value={label}
            sx={styles.tabStyle(label === currentTab)}
          />
        );
      })}
    </Tabs>
  );
};

export default ServicesRequestsTabsNavigation;

const styles = {
  tabs: {
    minHeight: "fit-content",
    borderBottom: "1px solid var(--Gray-200, #E4E7EC)",
    "& .MuiTabs-flexContainer": {
      gap: "24px",
    },
  },
  tabStyle: (isActive: boolean) => ({
    color: isActive ? "var(--Brand-700, #076D0D)" : "var(--Gray-500, #667085)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    padding: "0px 4px 12px 4px",
    textTransform: "none",
    minHeight: "36px",
    minWidth: "fit-content",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  }),
  badge: {
    display: "flex",
    padding: "2px 8px",
    alignItems: "center",
    borderRadius: "16px",
    border: "1px solid var(--Brand-25, #F6FFF5)",
    background: "var(--Brand-600, #008B07)",
    color: "var(--White, #FFF)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
};
